module.exports = __webpack_public_path__ + "img/85.7af5be4f.jpg";